import { EngineDeactivationReasonEnum } from '@/constants/engine-deactivation-reason';

export const validateProactiveEngineActivationBox = (
  isProactiveEngineStateActivated: boolean,
  commentRef: EngineDeactivationReasonEnum,
  comment: string,
) => {
  return (
    !isProactiveEngineStateActivated ||
    (commentRef &&
      (![EngineDeactivationReasonEnum.OtherReason, EngineDeactivationReasonEnum.EcoplantReason].includes(commentRef) ||
        !!comment))
  );
};
